import { takeLatest, put, take, call, cancel } from 'redux-saga/effects';
import size from 'lodash/size';

import { hideLoaderInPopup, showLoaderInPopup } from '../../ui/popup';
import * as schedulingTree from '../requests/schedulable-tree-req';
import * as myProviders from '../requests/my-providers-req';
import { appointmentProgressActions } from '../progress-types';
import { redirectToOrganizations } from '../../../utils/appointments/redirect-utils';

function* fetchOrganizationsByUserID({ payload: data }) {
  yield put(showLoaderInPopup());
  yield put(schedulingTree.actions.send({ ...data }));
  const { payload } = yield take(schedulingTree.consts.SUCCEED);

  yield put(hideLoaderInPopup());
  const orgSize = size(payload.organizations);

  if (orgSize === 1) {
    yield put(
      appointmentProgressActions.setOrganization(payload.organizations[0]),
    );
    yield put(myProviders.actions.init(payload.organizations[0]));
    yield cancel();
  }

  yield call(redirectToOrganizations);
}

export default function* organizationListGuard() {
  yield takeLatest(schedulingTree.consts.INIT, fetchOrganizationsByUserID);

  yield takeLatest(
    [schedulingTree.consts.REJECTED, schedulingTree.consts.ERROR_ENCOUNTERED],
    function* handleFailedReq() {
      yield put(hideLoaderInPopup());
    },
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/organization-list-guard-saga.js